import { Component, Input, OnInit } from '@angular/core';
import { Collection } from '../../../shop/models';

@Component({
    selector: 'app-collection-card',
    templateUrl: './collection-card.component.html',
    standalone: false
})
export class CollectionCardComponent {
  @Input() collection?: Collection;

  placeholderImageUrl = 'https://cdn.shopify.com/s/files/1/0622/3881/8561/collections/placeholder.png';

  constructor() {}
}
